import styled from "styled-components"
import { Link } from "gatsby"
import { palette } from "../../styles/global"
import { up, down, between, only } from "styled-breakpoints"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"

type ScrollProps = {
  scroll: number
}

export const Navigation = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
`

export const Wrapper = styled.header`
  ${down("lg")} {
    padding: 0 0 0 0;
    width: 100vw;
  }
  ${up("lg")} {
    padding: 0 7vw 0 7vw;
    width: calc(100vw - 14vw);
  }
  background: #ffffff 0% 0% no-repeat padding-box;
`

export const Content = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`

export const MenuWrapper = styled.nav`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  ${down("lg")} {
    display: none;
  }
`

export const LogoWrapper = styled.div`
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  ${down("lg")} {
    padding: 1.5vw 0 0 1.5vw;
  }
  transition: all 0.5s;
`

export const Logo = styled(GatsbyImage)<ScrollProps>`
  transition: all 0.5s;
  width: ${props => (props.scroll < 100 ? "160px" : "150px")};
  ${down("lg")} {
    width: 120px;
  }
  ${down("md")} {
    width: 90px;
  }
  ${down("sm")} {
    width: 70px;
    margin-left: 2rem;
  }
`
